/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:messageUtility
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/17 | 富士通株式会社         | 新規作成
// 01.01.00 | 2024/09/17 | 富士通Japan株式会社    | 令和6年度改修対応（1次リリース）
//================================================================================
 */
import store from '@/store/store.js';

import { STORE_MSG_GET_MSG } from '@/const/store.js';
import { E0042, E0074, E0064 } from '@/const/messageId.js';

/*
 * メッセージIDからメッセージ文字列を取得
 * @param {String} msgId メッセージID
 * @param {String | Array} 置換文字
 * @return {String} メッセージ
 */
export function co_getMessage(msgId) {

	let msg = store.getters[STORE_MSG_GET_MSG](msgId);

	// 利用者本登録時、メッセージ一覧取得前にエラーが発生した場合、定数よりメッセージを設定
	if (msg == 'E0042') {
		msg = E0042;
	}
	if (msg == 'E0074') {
		msg = E0074;
	}
	if (msg == 'E0064') {
		msg = E0064;
	}

	for (let i = 1; i < arguments.length; i++) {
		let retlink = msg.indexOf('%A'+ (i));
		if (retlink >= 0) {
			msg = msg.replace('%A'+ (i) + 'S', '<a href="' + arguments[i] + '" target="_blank" rel="noopener noreferrer" tabindex="-1">');
			msg = msg.replace('%A'+ (i) + 'E', '</a>');
		}
	}

	if ( arguments.length == 2 && Array.isArray(arguments[1]) ) {
		// 第2引数が配列の場合
		for (let i = 0; i < arguments[1].length; i++) {
			msg = msg.replace(new RegExp('[%]' + (i+1), 'g'), arguments[1][i]);
		}

	} else {
		// 第2引数以降の引数が置換文字の場合
		for (let i = 1; i < arguments.length; i++) {
			msg = msg.replace(new RegExp('[%]' + i, 'g'), arguments[i]);
		}
	}

	return msg;
}


